import Columns from "../../../library/components/layout/Columns";
import Rows from "../../../library/components/layout/Rows";
import GenelDurumHelper from "../../../helpers/GenelDurumHelper";
import { Button } from "@mui/material";
import { appIcons } from "../../../app/appIcons";
import Cell from "../../../library/components/layout/Cell";
import { EnmCinsiyet } from "../../../models/enums/EnmCinsiyet";
import { SecmeBasvuruModel } from "../../../models/businessModels/SecmeBasvuruModel";
import KorocanThumbnailIcerikId from "../../../components/business/KorocanThumbnailIcerikId";
import { CsmText } from "../../../library/components/mui/CsmText";
import CsmGenericGroupBox from "../../../library/components/mui/CsmGenericGroupBox";
import VatanNotaSlider from "../../../components/vatan/VatanNotaSlider";
import VatanSecmePuanSlider from "../../../components/vatan/VatanSecmePuanSlider";
import { BusinessHelper } from "../../../helpers/BusinessHelper";
import { useScreenWidth } from "../../../library/components/hooks/useScreenWidth";
import StringHelper from "../../../library/helpers/StringHelper";

interface ISecmeSonucBilgiPopupDisplayerProps {
    secmeBasvuruModel: SecmeBasvuruModel,
    genelDurumHelper: GenelDurumHelper,
    closer: (model: boolean | null) => void,
}

function TitlePair(_props: { title: string, value: string | null | undefined }) {
    const valueFormatted = StringHelper.emptyToDash(_props.value);
    return <Columns><CsmText bold>{_props.title}:</CsmText><CsmText style={{ marginLeft: "5px" }}>{valueFormatted}</CsmText></Columns>
}

function SecmeSonucBilgiPopupDisplayer(props: ISecmeSonucBilgiPopupDisplayerProps) {
    const { secmeBasvuruModel, closer, genelDurumHelper } = props;

    const secmeBasvuruSonucModel = secmeBasvuruModel.sonucModel!;

    const isVerySmall = useScreenWidth() === "Max600"

    // others

    const sliderWidth = isVerySmall ? 250 : 375;

    const tayinEdilenSesGrubu = secmeBasvuruSonucModel.sonucSesGrup === null ? "" : genelDurumHelper.SeciliKoroModel.tumSesGruplari.single(e => e.id === secmeBasvuruSonucModel.sonucSesGrup).isim;

    return (
        <Rows>
            <CsmGenericGroupBox label="Başvuru Bilgileri">
                <Columns wrap dontGrowForChild mt={8}>
                    <Columns>
                        <KorocanThumbnailIcerikId
                            title={`${secmeBasvuruModel.ad} ${secmeBasvuruModel.soyad}`}
                            icerikId={secmeBasvuruModel.resimIcerikId}
                            saveToStorage="None"
                            genelDurumHelper={genelDurumHelper}
                            size="large" />
                        <Rows ml={10} style={{ maxWidth: "250px", minWidth: "200px" }}>
                            <CsmText header>{`${secmeBasvuruModel.ad} ${secmeBasvuruModel.soyad}`}</CsmText>
                            <CsmText note>{`${secmeBasvuruModel.eposta}`}</CsmText>
                            <CsmText>{`${EnmCinsiyet[secmeBasvuruModel.cinsiyet]} / ${secmeBasvuruModel.dogumYili}`}</CsmText>
                            <TitlePair title="Ses Grubu" value={secmeBasvuruModel.bilinenSesGrubu} />
                        </Rows>
                    </Columns>
                    <Rows ml={10}>
                        <TitlePair title="Telefon" value={secmeBasvuruModel.telefon} />
                        <TitlePair title="Meslek" value={secmeBasvuruModel.meslek} />
                        <TitlePair title="Eğitim Durumu" value={secmeBasvuruModel.egitimDurumu} />
                        <TitlePair title="Yaşadığı İl" value={secmeBasvuruModel.yasadigiIl} />
                    </Rows>
                    <Rows ml={10}>
                        <span><b>Koro Tecrübesi</b>: {secmeBasvuruModel.koroTecrubesi}</span>
                        <span><b>Seçme Ön Notu</b>: {secmeBasvuruModel.secmeNotu}</span>
                    </Rows>
                </Columns>
            </CsmGenericGroupBox>
            <CsmGenericGroupBox label="Kulak Analizi">
                <Columns wrap mt={8} dontGrowForChild>
                    <Rows ml={10}>
                        <Columns hasLightBottomBorder width={sliderWidth} mr={5} mb={10} pb={15} style={{ placeItems: "center" }}>
                            <Rows flex>
                                <CsmText bold>Normal Melodi</CsmText>
                                <VatanSecmePuanSlider value={secmeBasvuruSonucModel.normalMelodiPuan} allowNull disabled />
                            </Rows>
                            <Cell width={100} ml={15} mt={20}>
                                <CsmText header>{secmeBasvuruSonucModel.normalMelodiPuan?.toFixed(1) ?? "-"}</CsmText>
                            </Cell>
                        </Columns>
                        <Columns width={sliderWidth} mr={5} mb={10} style={{ placeItems: "center" }}>
                            <Rows flex>
                                <CsmText bold>Arıza Melodi</CsmText>
                                <VatanSecmePuanSlider value={secmeBasvuruSonucModel.arizaMelodiPuan} allowNull disabled />
                            </Rows>
                            <Cell width={100} ml={15} mt={20} >
                                <CsmText header>{secmeBasvuruSonucModel.arizaMelodiPuan?.toFixed(1) ?? "-"}</CsmText>
                            </Cell>
                        </Columns>
                        <Columns hasLightBottomBorder width={sliderWidth} mr={5} mb={10} pb={15} style={{ placeItems: "center" }}>
                            <Rows flex>
                                <CsmText bold>İnce Nota</CsmText>
                                <VatanNotaSlider disabled allowNull value={secmeBasvuruSonucModel.inceNota} cinsiyet={secmeBasvuruModel.cinsiyet} />
                            </Rows>
                            <Rows width={100} ml={15} mt={20} >
                                <CsmText header>{BusinessHelper.Nota.NotaIsimGetir(secmeBasvuruSonucModel.inceNota)} {BusinessHelper.Nota.NotaOktavGetir(secmeBasvuruSonucModel.inceNota)}</CsmText>
                                <CsmText note>{BusinessHelper.Nota.ZorlukAciklamaGetir(secmeBasvuruSonucModel.inceNota, secmeBasvuruModel.cinsiyet === EnmCinsiyet.Erkek)}</CsmText>
                            </Rows>
                        </Columns>
                        <Columns hasLightBottomBorder width={sliderWidth} mr={5} mb={10} pb={15} style={{ placeItems: "center" }}>
                            <Rows flex>
                                <CsmText bold>Kalın Nota</CsmText>
                                <VatanNotaSlider disabled allowNull value={secmeBasvuruSonucModel.kalinNota} cinsiyet={secmeBasvuruModel.cinsiyet} />
                            </Rows>
                            <Rows width={100} ml={15} mt={20} >
                                <CsmText header>{BusinessHelper.Nota.NotaIsimGetir(secmeBasvuruSonucModel.kalinNota)} {BusinessHelper.Nota.NotaOktavGetir(secmeBasvuruSonucModel.kalinNota)}</CsmText>
                                <CsmText note>{BusinessHelper.Nota.ZorlukAciklamaGetir(secmeBasvuruSonucModel.kalinNota, secmeBasvuruModel.cinsiyet === EnmCinsiyet.Erkek)}</CsmText>
                            </Rows>
                        </Columns>

                    </Rows>
                    <Rows wrap ml={15} style={{ maxWidth: "650px" }}>
                        <span><b>Teknik Detaylar: </b>{StringHelper.emptyToDash(secmeBasvuruSonucModel.teknikDetaylar)}<br /><br /></span>
                        <span><b>Diğer Detaylar: </b>{StringHelper.emptyToDash(secmeBasvuruSonucModel.digerDetaylar)}<br /><br /></span>
                        <span><b>Tayin Edilen Ses Grubu: </b>{StringHelper.emptyToDash(tayinEdilenSesGrubu)}<br /><br /></span>

                        <CsmText bold>Sonuç</CsmText>
                        {secmeBasvuruSonucModel.sonuc === true && <Rows>{appIcons.Zorluk.uygun_maxi}<CsmText>Kazandı</CsmText></Rows>}
                        {secmeBasvuruSonucModel.sonuc === false && <Rows>{appIcons.Zorluk.uygunDegil_maxi}<CsmText>Kazanamadı</CsmText></Rows>}
                        {secmeBasvuruSonucModel != null && secmeBasvuruSonucModel.sonuc === null && <Rows>{appIcons.Zorluk.bilinmiyor_maxi}<CsmText>Belirsiz</CsmText></Rows>}
                        {secmeBasvuruSonucModel === null && <Rows><CsmText>Seçmelere Katılmadı</CsmText></Rows>}


                    </Rows>
                </Columns>
            </CsmGenericGroupBox>
            <Columns height={60} mt={10}>
                <Button color="info" variant="contained" onClick={() => closer(null)} style={{ flex: 1, margin: 10, marginLeft: 0 }}>
                    {appIcons.Popup.tamam}
                    {genelDurumHelper.translate("Tamam")}</Button>
            </Columns>
        </Rows >
    );
}

export default SecmeSonucBilgiPopupDisplayer;